module.exports = __webpack_public_path__ + "media/vitb-machine-vision-demo.c79c290a.mp4";